






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";

export default Vue.extend({
  props: ["paymentVndTransactionId"],
  data() {
    return {
      self: this,
      tableOptions: null,
    };
  },
  methods: {
    makeTableOptions() {
      const self = this;
      return {
        attrs: {
          "item-key": "_id",
          "sort-by": "time",
          "sort-desc": true,
        },
        content: {
          name: "Chi tiết giao dịch",
          search: {},
          displayFields: {
            time: {
              text: "Thời gian",
              sortable: true,
              options: { filter: "dateTime" },
            },
            name: {
              text: "Tên",
              sortable: true,
            },
            description: {
              text: "Mô tả",
            },
            amount: {
              text: "Số tiền thu",
              sortable: true,
              options: { filter: "number3" },
            },
            spentAmount: {
              text: "Số tiền chi",
              sortable: true,
              options: { filter: "number3" },
            },
            exchangeRate: {
              text: "Tỷ giá",
              sortable: true,
              options: { filter: "number3" },
            },
            currency: {
              text: "Loại tiền tệ",
              sortable: true,
            },
            action: {},
          },
          topActionButtons: {
            insert: userManager.checkRole(["kt"]) && {},
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["kt"]) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "name",
                    },
                  },
                },
              },
              delete: userManager.checkRole(["admin"]) && {},
            },
          },
          findAllOptionsFilter(options) {
            options.filters.push({
              key: "paymentVndTransactionId",
              operator: "equal_to",
              value: self.paymentVndTransactionId,
            });
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call(
                "paymentVndTransactionDetails",
                "findAll",
                options,
                undefined,
                undefined,
                "viewProtectedPage3"
              );
              return [items, count];
            },
            async insert(item) {
              item.paymentVndTransactionId = self.paymentVndTransactionId;
              return await coreApiClient.call(
                "paymentVndTransactionDetails",
                "create",
                undefined,
                item,
                undefined,
                "viewProtectedPage3"
              );
            },
            async update(item) {
              return await coreApiClient.call(
                "paymentVndTransactionDetails",
                "update",
                { id: item._id },
                { data: item },
                undefined,
                "viewProtectedPage3"
              );
            },
            async delete(item) {
              return await coreApiClient.call(
                "paymentVndTransactionDetails",
                "delete",
                { id: item._id },
                undefined,
                undefined,
                "viewProtectedPage3"
              );
            },
          },
          default: {
            defaultInputs: {
              time: {
                type: "XDateTimePicker",
                attrs: {
                  label: "Thời gian",
                  required: true,
                },
              },
              name: {
                type: "text",
                attrs: {
                  label: "Tên",
                  required: true,
                },
              },
              description: {
                type: "textLarge",
                attrs: {
                  label: "Mô tả",
                },
              },
              amount: {
                type: "number",
                attrs: {
                  label: "Số tiền thu",
                },
              },
              spentAmount: {
                type: "number",
                attrs: {
                  label: "Số tiền chi",
                },
              },
              exchangeRate: {
                type: "number",
                attrs: {
                  label: "Tỷ giá",
                },
              },
              currency: {
                type: "text",
                attrs: {
                  label: "Loại tiền tệ",
                },
              },
            },
            insertForm: {
              content: {
                fieldNames: ["time", "name", "description", "amount", "spentAmount", "exchangeRate", "currency"],
              },
            },
            editForm: {
              content: {
                fieldNames: ["time", "name", "description", "amount", "spentAmount", "exchangeRate", "currency"],
              },
            },
            delete: {
              confirmDisplayField: "name",
            },
          },
        },
      };
    },
  },
  async created() {
    this.tableOptions = this.makeTableOptions();
  },
});
